module.exports = __webpack_public_path__ + "img/close.52351984.png";